export default __webpack_public_path__ + "static/media/simplify_logo2C.65bf470c.png";